import { jsx as _jsx } from "react/jsx-runtime";
import { Children, isValidElement, } from 'react';
import { Boolean, Color, Component, Header, Number, Object, Text, } from '../value-renderers';
import { useTableContext } from './tableContext';
export const TableRow = ({ children, style = {}, bordered = false, ...other }) => {
    const { cells } = useRowChildren(children);
    return (_jsx("tr", { style: { border: bordered ? '1px solid black' : '', ...style }, ...other, children: cells }));
};
function useRowChildren(children) {
    const cells = [];
    const { color } = useTableContext();
    for (const child of Children.toArray(children)) {
        if (typeof child === 'object' &&
            isValidElement(child) &&
            (child.type === Color ||
                child.type === Boolean ||
                child.type === Text ||
                child.type === Number ||
                child.type === Object ||
                child.type === Header ||
                child.type === Component)) {
            if (child.type === Header) {
                cells.push(_jsx("th", { style: { color }, children: child }, child.key));
            }
            else {
                cells.push(_jsx("td", { style: {
                        color,
                        position: 'relative',
                    }, children: child }, child.key));
            }
        }
        else {
            // eslint-disable-next-line no-console
            console.error('Invalid Row child:', child);
            throw new Error('invalid Row child');
        }
    }
    return { cells };
}
//# sourceMappingURL=TableRow.js.map